import { useRef } from 'react';

/* eslint-disable @typescript-eslint/no-empty-object-type */
/**
 * Takes multiple hooks that follow the composable pattern and merges them into a single hook.
 *
 * A "composable" hook is one that:
 *
 * - takes 2 arguments
 *   1. an object of react props
 *   2. a "shared" object that can be used to pass state and methods between hooks
 * - returns an object of props
 * - includes all unused props unmodified in the returned object
 * - calls any event handlers passed to it when providing an event handler of its own
 *
 * @example
 *
 * ```tsx
 * const useComposedHook = composeHooks(useHookA, useHookB, useHookC)
 *
 * function MyComponent(propsIn: IntersectionOfPropsPassedToAllComposedHooks) {
 *  const [props, shared] = useComposedHook(propsIn)]
 * }
 * ```
 */
function composeHooks(...hooks) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return ((props, sharedIn) => {
        const shared = useRef({});
        if (sharedIn) {
            Object.assign(shared.current, sharedIn);
        }
        for (const hook of hooks) {
            props = hook(props, shared.current);
        }
        return props;
    });
}

export { composeHooks };
//# sourceMappingURL=compose-hooks.js.map
